import { Modal } from '@mui/base';
import Dialog from '@mui/material/Dialog';
import { Backdrop } from '@mui/material';
import Player, { PlayerProps } from "./trackVideoPlayer";
interface VideoPlayerProps extends PlayerProps {
  onClose: ()=> void;
}

const VideoPlayer = (props: VideoPlayerProps) => {
  return <Dialog
    open={props.open}
    onClose={props?.handleClose}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
    className="videoModal"
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        style: {
          zIndex: 999,
        }
      }
    }}
  >
    <Player {...props} />
  </Dialog>
}

export default VideoPlayer;